<template>
  <div
    class="list-noti"
  >
    <div v-for="(item, index) in listNotifications" :key="index" class="list-noti--item">
      <div
        :class="{
          icon: true,
          system: item.content.data.type,
          timekeeping: !item.content.data.type,
        }"
      >
        <i
          :class="{
            'icon24-VB_DaChoYKien': item.content.data.type,
            'icon24-LichSu': !item.content.data.type,
          }"
        ></i>
      </div>
      <div class="content">
        <p class="message" :title="item.content.message">{{ item.content.message }}</p>
        <p class="created-time" :title="formatDateTime(item.createdTime)">
          {{ formatDateTime(item.createdTime) }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import MethodService from "@/service/MethodService";
import NotificationApi from "@/moduleApi/NotificationApi";
export default {
  data() {
    return {
      currentUser: MethodService.getCurrentUser(),
      listNotifications: [],
      limit: 10,
    };
  },
  methods: {
    // A function that is called when the component is created. It will call the API to get the
    // list of notifications.
    async getListNoti() {
      const notiApiRes = await NotificationApi.list({
        filters: `toUserId=${this.currentUser.id}`,
        limit: this.limit,
        sort: "-createdTime",
      });
      this.listNotifications = notiApiRes.result
    },
    // A method that is being called in the Vue HTML.
    formatDateTime(value) {
      return MethodService.formatDate(value, "datetime");
    },
  },
  created() {
    this.getListNoti()
  },
};
</script>
<style lang="scss" scoped>
::v-deep p {
  font-family: "LexendDeca Regular";
}
::v-deep .list-noti {
  &--item {
    display: grid;
    grid-template-columns: 60px auto;
    align-self: center;
    margin-bottom: 15px;
    .icon {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      align-self: center;
      &.system {
        background: #ff5621;
      }
      &.timekeeping {
        background: #f79e61;
      }
      [class^="icon24-"],
      [class*=" icon24-"] {
        color: #fff;
        font-size: 27px;
      }
    }
    .content {
      align-self: center;
      .message {
        font-weight: 400;
        font-size: 15px;
        line-height: 24px;
        color: #292d32;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        word-break: break-word;
        -webkit-box-orient: vertical;
      }
      .created-time {
        font-weight: 200;
        font-size: 13px;
        line-height: 16px;
        color: #444242;
      }
    }
  }
}
</style>
